import classNames from 'classnames';
import { useIntercom } from 'react-use-intercom';

import { isMobileAppContext } from '@/services/loginService';

import useMixpanel from '../../../hooks/useMixpanel';
import styles from './index.module.scss';

export const SupportLink = () => {
  const { showNewMessage } = useIntercom();
  const { track } = useMixpanel();
  const openChat = () => {
    track('login_chat_support');
    showNewMessage("I'm having trouble signing in");
  };
  return (
    <div
      className={classNames(
        styles.supportLink,
        'leading-5 text-sm font-normal text-neutrals-n-400 flex flex-col items-center text-center',
      )}
    >
      Having trouble signing in?
      <span>
        Send us a{' '}
        <span
          className={classNames('underline cursor-pointer hover:opacity-75', styles.blue)}
          onClick={() => {
            openChat();
          }}
        >
          message
        </span>{' '}
        or Email us at{' '}
        <a
          href="mailto:support@onestep.co"
          target="_blank"
          className="underline cursor-pointer hover:opacity-75"
          onClick={() => {
            // This for mobile
            if (isMobileAppContext()) {
              window.location.replace(
                `https://outlook.office.com/mail/deeplink/compose?mailtouri=mailto:support@onestep.co`,
              );
            }
          }}
          role="link"
        >
          support@onestep.co
        </a>
      </span>
    </div>
  );
};
